export default {
    install: function (Vue) {
        Vue.mixin({
            methods: {
                // TODO: Refactor to $store
                getSelectedTradeName() {
                    return this.$store.getters.getTrades[this.$store.getters.getTrade].name
                },

                getSelectedLoadName() {
                    return this.$store.getters.getTrades[this.$store.getters.getTrade].vehicle_loads[this.$store.getters.getLoad].name
                },

                notEmptyObject(someObject) {
                    return Object.keys(someObject).length
                },

                refreshSlick(ref) {
                    // Refresh the carousel
                    if (this.$refs[ref]) {
                        let el = this.$refs[ref];
                        el.destroy();

                        this.$nextTick(() => {
                            if (this.$refs[ref]) {
                                el.create();

                                let event;
                                if(typeof(Event) === 'function') {
                                    event = new Event('matchheight');
                                }else{
                                    event = document.createEvent('CustomEvent');
                                    event.initEvent('matchheight', true, true);
                                }
                                document.dispatchEvent(event);
                            }
                        })
                    }
                },

                // eslint-disable-next-line
                slickHandleBreakpoint() {
                    let event;
                    if(typeof(Event) === 'function') {
                        event = new Event('matchheight');
                    }else{
                        event = document.createEvent('CustomEvent');
                        event.initEvent('matchheight', true, true);
                    }
                    document.dispatchEvent(event);
                }
            }
        });
    }
}